export const APP_DIMENSIONS = {
  STRACK_TRACE: 'stack_trace',
  TAG_KEY: 'tag_key',
  TAG_VALUE: 'tag_value',
  ERROR_INFO: 'error_info',
  PLATFORM: 'platform',
  APP_ID: 'app_id',
  APPLICATION_VERSION: 'application_version',
} as const;

export const MAPPED_EVENT_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.TAG_KEY,
    header: 'Tag Key',
  },
  {
    dimension: APP_DIMENSIONS.TAG_VALUE,
    header: 'Tag Value',
  },
];

export const APP_ERROR_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.STRACK_TRACE,
    header: 'Stack Trace',
  },
  {
    dimension: APP_DIMENSIONS.ERROR_INFO,
    header: 'Error Message',
  },
];

export const APP_ERROR_MODAL_EXPLORE_DIMENSIONS = [
  {
    dimension: APP_DIMENSIONS.ERROR_INFO,
    header: 'Error Message',
  },
  {
    dimension: APP_DIMENSIONS.STRACK_TRACE,
    header: 'Stack Trace',
  },
];
